import { render, staticRenderFns } from "./ArboDocs.vue?vue&type=template&id=0d33a73f&scoped=true&"
import script from "./ArboDocs.vue?vue&type=script&lang=js&"
export * from "./ArboDocs.vue?vue&type=script&lang=js&"
import style0 from "./ArboDocs.vue?vue&type=style&index=0&id=0d33a73f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d33a73f",
  null
  
)

export default component.exports